import FusionQueryError from './FusionQueryError';

/**
 * Factory function that is used to create a transformErrorResponse handler for an endpoint.
 * @param  {...any} statusCodesArray 
 * @returns {Function} Returns a function that can be passed to transformErrorResponse for an endpoint.
 * @example
 * getResultCount: builder.query({
      query: ({ type = 'providers', ...params }) => ({ url: `/${type}/count/`, params }),
      transformErrorResponse: reportStatusCodes(404, 404, 502)
    }),
 */
export const reportStatusCodes =
  (...statusCodesArray) =>
  (error, meta, arg) => {
    const fusionError = new FusionQueryError({ error, meta }, arg);
    if (fusionError.shouldReportGlobally) return error; // assume that this error was already reported by the global fusion error handler
    if (statusCodesArray.includes(fusionError.status)) fusionError.report();
    return error;
  };

export const reportAllErrors = (error, meta, arg) => {
  const fusionError = new FusionQueryError({ error, meta }, arg);
  if (fusionError.shouldReportGlobally) return error; // assume that this error was already reported by the global fusion error handler
  fusionError.report();
  return error;
};
